<template>
  <div class="instructions">
    <SiestaHeader />
    <div class="vertical-spacer"></div>
    <p
      class="can-you-spot text1"
    >Can you spot the 5 differences between these two photos? It’s time to be a detective and get to sleuthing! Watch out for who you tell the right answers to. Secrets aren't safe in Siesta Key.</p>

    <div class="vertical-spacer"></div>
    <div class="instructables">
      <SiestaInstruction max-width="180px" :msg="msgHints" :icon="magnifier" />
      <div class="horizontal-spacer"></div>
      <SiestaInstruction max-width="320px" :msg="msgClock" :icon="clock" />
    </div>
    <router-link class="button" to="/activity">{{buttonCopy}}</router-link>
    <SiestaFooter :is-results="false" />
  </div>
</template>

<script>
import SiestaHeader from "@/components/SiestaHeader";
import SiestaFooter from "@/components/SiestaFooter";
import SiestaInstruction from "@/components/instructions/SiestaInstruction";

export default {
  name: "instructions",
  data() {
    return {};
  },
  components: {
    SiestaHeader,
    SiestaFooter,
    SiestaInstruction
  },
  computed: {
    game() {
      return this.$store.state.game;
    },
    buttonCopy() {
      return this.$store.state.game.paused ? "Continue" : "Let's play!";
    },
    msgHints() {
      return "USE 3 hints<br />for help";
    },
    msgClock() {
      return "Beat the clock and get more points,<br />Wrong clicks lose time";
    },
    clock() {
      return require("@/assets/clock.svg");
    },
    magnifier() {
      return require("@/assets/magglass.svg");
    }
  }
};
</script>

<style lang="scss" scoped>
.instructions {
  padding: rems(24px) rems(24px) rems(32px) rems(24px);
  text-align: center;
  position: relative;
}
.can-you-spot {
  max-width: rems(600px);
  margin: rems(24px) auto;
  width: 100%;
}

.horizontal-spacer {
  height: rems(82px);
  margin: rems(16px);
}
.instructables {
  margin: rems(40px) auto;
  max-width: rems(720px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.tiny .instructables {
  justify-content: space-around;
}
.button {
  margin: 0 0 rems(30px) 0;
}
</style>
